module.exports = __webpack_public_path__ + "media/images/dashboard-matrix-66589e4f.png";